const useMockTables = false; // Set to false to switch to production tables later.

export const TABLE_NAMES = {
    ACADEMIES: useMockTables ? 'academies_mock' : 'academies',
    USERS: useMockTables ? 'Users_mock' : 'Users',
    TEAMS: useMockTables ? 'teams_mock' : 'teams',
    TEAM_MEMBERS: useMockTables ? 'team_members_mock' : 'team_members',
    GAMES: useMockTables ? 'Games_mock' : 'Games',
    SCHEDULES: useMockTables ? 'schedules_mock' : 'schedules',
    STATS: 'Stats',
    TEMP_STATS: 'TempStats',
    VIDEO_ANALYSIS_STATE: 'video_analysis_state',
    CLIENT_FREEZE_LOGS: 'client_freeze_logs',
    COMMUNITIES: 'communities',
    COMMUNITY_PARTICIPANTS: 'community_participants',
    COMMUNITY_GROUPS: 'community_groups',
    COMMUNITY_GROUP_MEMBERS: 'community_group_members',
    COMMUNITY_CLIPS: 'community_clips',
    ACADEMY_CLIPS: 'academy_clips',
    COMMUNITY_ZONES: 'community_zones',
    COMMUNITY_LOCATIONS: 'community_locations',
    ACADEMY_LOCATIONS: 'academy_locations',
    ACADEMY_BRANCHES: 'academy_branches',
    COMMUNITY_MANAGER_ONBOARDING: 'community_manager_onboarding',
    COMMUNITY_OPPONENTS: 'community_opponents',
    GAME_OPPONENTS: 'game_opponents',
    BASIC_GAMES: 'basic_games',
    VENUES: 'replay_venues',
    ACADEMY_VIDEO_SESSIONS: 'academy_video_sessions',
    TRAINING_SESSION_ATTENDANCE: 'training_session_attendance',
    TRAINING_SESSIONS: 'training_sessions',
    ACADEMY_TEAM_SUBSCRIPTIONS: 'academy_team_subscriptions',
};

export const RELATION_KEYS = {
    USER_ACADEMY: useMockTables
        ? `${TABLE_NAMES.ACADEMIES}!Users_mock_academy_id_fkey`
        : `${TABLE_NAMES.ACADEMIES}!Users_academy_id_fkey`
};

export const userAcademySelect = (fields = 'name') =>
    `academy:${RELATION_KEYS.USER_ACADEMY}(${fields})`;

